import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NbDialogService } from '@nebular/theme';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';
import { environment } from 'src/environments/environment';
import { ConfirmApprovalModalComponent } from '../../Modalla-Popup/confirm-approval-modal/confirm-approval-modal.component';
import { FormApprovalSuccessModalComponent } from '../../Modalla-Popup/form-approval-success-modal/form-approval-success-modal.component';
import { FormRejectionSuccessModalComponent } from '../../Modalla-Popup/form-rejection-success-modal/form-rejection-success-modal.component';
import { ConfirmRejectionModalComponent } from '../../Modalla-Popup/confirm-rejection-modal/confirm-rejection-modal.component';
import { AddNotesModalComponent } from '../../Modalla-Popup/add-notes-modal/add-notes-modal.component';
import { ConfirmSendToFirstAidModalComponent } from '../../Modalla-Popup/confirm-send-to-first-aid-modal/confirm-send-to-first-aid-modal.component';
import { Router } from '@angular/router';
import { NotesAddedSucesfulModalComponent } from '../../Modalla-Popup/notes-added-sucesful-modal/notes-added-sucesful-modal.component';
import { CONSTANTS } from 'src/Core/Constant';
import { ChangeStateModalComponent } from '../../Modalla-Popup/change-state-modal/change-state-modal.component';

@Component({
  selector: 'app-approve-rected-action',
  templateUrl: './approve-rected-action.component.html',
  styleUrls: ['./approve-rected-action.component.scss']
})
export class ApproveRectedActionComponent {

  decisionForm!: FormGroup;
  userData: any = {}
  isJsonShow = environment.isJsonShow;  // Set isJsonShow from the environment

  // State options array mapping to enumApplicationState
  stateOptions = [
    { value: CONSTANTS.ApplicationState.DRAFT, label: 'Draft', enumValue: CONSTANTS.ApplicationState.DRAFT },
    { value: CONSTANTS.ApplicationState.SUBMITTED_APP_REVIEW, label: 'Submitted APP Review', enumValue: CONSTANTS.ApplicationState.SUBMITTED_APP_REVIEW },
    { value: CONSTANTS.ApplicationState.NEED_EDITS_APP, label: 'Need Edits APP', enumValue: CONSTANTS.ApplicationState.NEED_EDITS_APP },
    { value: CONSTANTS.ApplicationState.UNDER_GURUKULA_REVIEW, label: 'Under Gurukula Review', enumValue: CONSTANTS.ApplicationState.UNDER_GURUKULA_REVIEW },
    { value: CONSTANTS.ApplicationState.NEED_EDITS_GURUKULA, label: 'Need Edits Gurukula', enumValue: CONSTANTS.ApplicationState.NEED_EDITS_GURUKULA },
    { value: CONSTANTS.ApplicationState.NEED_EDITS_GURUKULA_TO_APP, label: 'Need Edits Gurukula To APP', enumValue: CONSTANTS.ApplicationState.NEED_EDITS_GURUKULA_TO_APP },
    { value: CONSTANTS.ApplicationState.APPROVED, label: 'Approved', enumValue: CONSTANTS.ApplicationState.APPROVED },
    { value: CONSTANTS.ApplicationState.WAITLIST, label: 'Waitlist', enumValue: CONSTANTS.ApplicationState.WAITLIST },
    { value: CONSTANTS.ApplicationState.NON_APPROVED, label: 'Non Approved', enumValue: CONSTANTS.ApplicationState.NON_APPROVED },
    { value: CONSTANTS.ApplicationState.INVALID, label: 'Invalid', enumValue: CONSTANTS.ApplicationState.INVALID },
    { value: CONSTANTS.ApplicationState.CLOSED, label: 'Closed', enumValue: CONSTANTS.ApplicationState.CLOSED },
    { value: CONSTANTS.ApplicationState.CANCELLED, label: 'Cancelled', enumValue: CONSTANTS.ApplicationState.CANCELLED }
  ];

  constructor(private router: Router, private dialogService: NbDialogService, private fb: FormBuilder, private api: SevaProfileService,) {
  }
  
  ngOnInit(): void {

    this.userData = history.state.rowData;
    this.initializeForm();
  }



  initializeForm() {
    this.decisionForm = this.fb.group({
      decisionOutcome: ['', Validators.required],
      comment: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10000)]],
      ApplicationGuid: [this.userData.ApplicationGuid],
      SevaProfileDisplayUID: [this.userData.SevaProfileDisplayUID],
    });
  }


  submitForm() {
    if (this.decisionForm.valid) {
      console.log('Form Submitted:', this.decisionForm.value);
      this.changeState(this.decisionForm.value);
    } else {
      console.error('Form is invalid');
      // Mark all fields as touched to show validation errors
      Object.keys(this.decisionForm.controls).forEach(key => {
        this.decisionForm.get(key)?.markAsTouched();
      });
    }
  }

  changeState(param: any) {
    let requestBody = {
      ApplicationGuid: param.ApplicationGuid,
      SevaProfileDisplayUID: param.SevaProfileDisplayUID,
      FinalRemarks: param.comment,
      DecisionOutcome: param.decisionOutcome
    };
    console.log('Request Body:', requestBody);
    var endPoint = 'GAO/Finalize';

    // Determine action type based on state for modal display
    const selectedState = this.stateOptions.find(s => s.enumValue === param.decisionOutcome);
    let actionType = 'ChangeState';
    
    if (param.decisionOutcome === CONSTANTS.ApplicationState.APPROVED) {
      actionType = 'Approve';
    } else if (param.decisionOutcome === CONSTANTS.ApplicationState.NON_APPROVED) {
      actionType = 'Reject';
    }

    this.finalApiCallBasedOnAction(actionType, endPoint, requestBody);
  }

  addNotesAction() {
    if (this.decisionForm.get('comment')?.valid) {
      this.addNotes(this.decisionForm.value);
    } else {
      // Show validation error for comment
      this.decisionForm.get('comment')?.markAsTouched();
      alert('Please enter a valid comment (between 10 and 10000 characters) before adding notes.');
    }
  }

  sendToFirstAidAction() {
    if (this.decisionForm.get('comment')?.valid) {
      this.sendToFirstAid(this.decisionForm.value);
    } else {
      // Show validation error for comment
      this.decisionForm.get('comment')?.markAsTouched();
      alert('Please enter a valid comment (between 10 and 10000 characters) before sending to First Aid.');
    }
  }






  addNotes(param: any) {
    let requestBody = {
      ApplicationGuid: param.ApplicationGuid,
      SubmittedOn: "2024-12-20T03:46:28.815Z",
      SubmittedBy: "string",
      Notes: param.comment,
      NotesCreatoTypeId: history.state.NotesCreatoTypeId
    }
    console.log('Request Body:', requestBody);
    var endPoint = 'Applicant/aaplication/AddNote'
    this.finalApiCallBasedOnAction('addNotes', endPoint, requestBody)
  }


  sendToFirstAid(param: any) {
    let requestBody = {
      ApplicationGuid: param.ApplicationGuid,
      TaggedForFirstNotes: "qwertyu",
      TaggedForFirstAidBy: "string",
      FinalRemarks: param.comment,
      IsApproved: false
    }
    console.log('Request Body:', requestBody);
    var endPoint = 'GAO/sendToFirstAid';
    this.finalApiCallBasedOnAction("sendToFirstAid", endPoint, requestBody)
  }




  finalApiCallBasedOnAction(actionType: any, endPoint: any, payload: any) {

    if (actionType == "Approve") {
      this.OpenApproveModal(payload, endPoint)
    }

    if (actionType == "Reject") {
      this.OpenRejectionModal(payload, endPoint)
    }

    if (actionType == "ChangeState") {
      // For state changes, use approval modal as default confirmation
      this.OpenApproveModal(payload, endPoint)
    }

    if (actionType == "addNotes") {
      this.OpenAddNotesModal(payload, endPoint)
    }

    if (actionType == "sendToFirstAid") {
      this.OpenSendToFirstAidModal(payload, endPoint)
    }


  }



  OpenApproveModal(payload: any, endPoint: any) {

    const dialogRef = this.dialogService.open<any>(ConfirmApprovalModalComponent, {
      context: {
        data: {
          requestBody: payload,
          endPoint: endPoint,
          isCommentBoxShow: true
        },
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });
    dialogRef.onClose.subscribe(res => {

      if (res === true) {
        this.FormApproveSucessfully()
        // this.getAllApplication();  // Handle approval
      } else {
        console.log('Modal canceled');
      }
    });
  }



  FormApproveSucessfully() {

    const dialogRef = this.dialogService.open(FormApprovalSuccessModalComponent, {
      context: {
        data: {
          'name': 'Chetan',
          'city': "Malegaon",
        }
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });

    dialogRef.onClose.subscribe(res => {

      if (res === true) {
        this.router.navigate(['/gao/applications'])
      } else {
        console.log('Modal canceled');
      }
    });

  }



  OpenRejectionModal(payload: any, endPoint: any) {
    const dialogRef = this.dialogService.open(ConfirmRejectionModalComponent, {
      context: {
        data: {
          requestBody: payload,
          endPoint: endPoint,
          isCommentBoxShow: true
        },
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });

    dialogRef.onClose.subscribe(res => {

      if (res === true) {
        // this.getAllApplication();  // Handle approval
        this.FormRejectSucessfully();
      } else {
        console.log('Modal canceled');
      }
    });
  }



  FormRejectSucessfully() {

    const dialogRef = this.dialogService.open(FormRejectionSuccessModalComponent, {
      context: {
        data: {
          'name': 'Chetan',
          'city': "Malegaon",
        }
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });

    dialogRef.onClose.subscribe(res => {

      if (res === true) {
        this.router.navigate(['/gao/applications'])
      } else {

      }
    });

  }




  OpenAddNotesModal(payload: any, endPoint: any) {
    const dialogRef = this.dialogService.open(AddNotesModalComponent, {
      context: {
        data: {
          requestBody: payload,
          endPoint: endPoint,
          isCommentBoxShow: true

        },
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });

    dialogRef.onClose.subscribe(res => {

      if (res === true) {
        // this.getAllApplication();  // Handle approval
        this.NotesAddedSucesfulModal();
      } else {

      }
    });
  }




  NotesAddedSucesfulModal() {

    const dialogRef = this.dialogService.open(NotesAddedSucesfulModalComponent, {
      context: {
        data: {
          'name': 'Chetan',
          'city': "Malegaon",

        }
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });

    dialogRef.onClose.subscribe(res => {

      if (res === true) {
        this.router.navigate(['/gao/applications'])
      } else {
        console.log('Modal canceled');
      }
    });

  }


  OpenSendToFirstAidModal(payload: any, endPoint: any) {
    const dialogRef = this.dialogService.open(ConfirmSendToFirstAidModalComponent, {
      context: {
        data: {
          requestBody: payload,
          endPoint: endPoint,
          isCommentBoxShow: true
        },
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });

    dialogRef.onClose.subscribe(res => {

      if (res === true) {
        // this.getAllApplication();  // Handle approval
        this.FormApproveSucessfully();
      } else {

      }
    });
  }


  goBack() {

  }

  openChangeStateModal() {
    // Create a temporary form for the modal
    const tempForm = this.fb.group({
      decisionOutcome: ['', Validators.required],
      comment: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10000)]],
      ApplicationGuid: [this.userData.ApplicationGuid],
      SevaProfileDisplayUID: [this.userData.SevaProfileDisplayUID],
    });

    // Open Change State Modal
    const dialogRef = this.dialogService.open(ChangeStateModalComponent, {
      context: {
        data: {
          stateOptions: this.stateOptions,
          formData: tempForm.value,
          userData: this.userData
        }
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });

    dialogRef.onClose.subscribe(res => {
      if (res === true) {
        // Handle success - navigate or show success message
        this.FormApproveSucessfully();
      }
    });
  }

  openAddNotesModal() {
    const tempForm = this.fb.group({
      comment: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10000)]],
      ApplicationGuid: [this.userData.ApplicationGuid],
      SevaProfileDisplayUID: [this.userData.SevaProfileDisplayUID],
    });

    let requestBody = {
      ApplicationGuid: this.userData.ApplicationGuid,
      SubmittedOn: new Date().toISOString(),
      SubmittedBy: "string",
      Notes: '',
      NotesCreatoTypeId: history.state.NotesCreatoTypeId
    };

    const dialogRef = this.dialogService.open(AddNotesModalComponent, {
      context: {
        data: {
          requestBody: requestBody,
          endPoint: 'Applicant/aaplication/AddNote',
          isCommentBoxShow: false
        },
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });

    dialogRef.onClose.subscribe(res => {
      if (res === true) {
        this.NotesAddedSucesfulModal();
      }
    });
  }

  openSendToFirstAidModal() {
    const tempForm = this.fb.group({
      comment: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10000)]],
      ApplicationGuid: [this.userData.ApplicationGuid],
      SevaProfileDisplayUID: [this.userData.SevaProfileDisplayUID],
    });

    let requestBody = {
      ApplicationGuid: this.userData.ApplicationGuid,
      TaggedForFirstNotes: "",
      TaggedForFirstAidBy: "string",
      FinalRemarks: '',
      IsApproved: false
    };

    const dialogRef = this.dialogService.open(ConfirmSendToFirstAidModalComponent, {
      context: {
        data: {
          requestBody: requestBody,
          endPoint: 'GAO/sendToFirstAid',
          isCommentBoxShow: false
        },
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });

    dialogRef.onClose.subscribe(res => {
      if (res === true) {
        this.FormApproveSucessfully();
      }
    });
  }
}
